import { SearchBolder, TableColumn, TableRow } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import { IBenchmarkSelectable, IColumn } from '../../models';

export interface IBenchmarkRowProps {
	benchmark: IBenchmarkSelectable;
	columns: IColumn[];
	selectable: boolean;
	searchText?: string;
	select?: (id: number) => void;
	disabled: boolean;
}

export class BenchmarkRow extends React.Component<IBenchmarkRowProps> {
	constructor(props: IBenchmarkRowProps) {
		super(props);

		this.getColumn = this.getColumn.bind(this);
		this.selectRow = this.selectRow.bind(this);
	}

	public render() {
		const { columns, disabled, selectable } = this.props;
		const selected = this.props.benchmark.selected;

		return (
			<TableRow selected={selected} selectable={selectable} onSelectRow={this.selectRow} disabled={disabled}>
				{_.map(columns, this.getColumn)}
			</TableRow>
		);
	}

	public selectRow() {
		const { benchmark, select, selectable } = this.props;

		if (selectable && select) {
			select(benchmark.benchmarkId);
		}
	}

	public getColumn(column: IColumn, index: any) {
		const { benchmark, searchText } = this.props;

		switch (column.name) {
			case 'displayText':
				return (
					<TableColumn key={index}>
						<SearchBolder searchText={searchText} text={benchmark.displayText} />
					</TableColumn>
				);
			case 'description':
				return (
					<TableColumn key={index}>
						<SearchBolder searchText={searchText} text={benchmark.description} />
					</TableColumn>
				);
		}

		return null;
	}
}
